import React from 'react';
import Moment from 'react-moment';
import {Link} from "react-router-dom";

const deal = (props) => {
    return (
        <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 spacing-all-category">
            <div className="category-box-outer border-grey">
                <Link to={{
                    pathname: process.env.PUBLIC_URL+'/reviews/rated/'+props.deal._id,
                    state: {
                        deal: props.deal
                    }
                }}>
                <div className="category-box-header">
                    <img src={props.deal.image}
                         alt={props.deal.name}/>
                </div>
                <div className="category-box-body">
                    <h1 className="date-01"><span><Moment format="DD" parse="DD-MM-YYYY">
                                    {props.deal.purchased_for_date ? props.deal.purchased_for_date : props.deal.dealdate}
                                </Moment></span><span> <Moment format="MMM" parse="DD-MM-YYYY">
                                    {props.deal.purchased_for_date ? props.deal.purchased_for_date : props.deal.dealdate}
                                </Moment></span></h1>
                    <div className="deal_rating_sec">
                        <h4 className="category-box-body-title custom-height">{props.deal.category.name}</h4>
                        <p className="category-box-body-subtitle custom-height">{props.deal.name}</p>
                    </div>
                </div>
                </Link>
            </div>
        </div>
    )
}

export default deal;